export default __webpack_public_path__ + "static/media/business.4fa93713.svg";